// 常量
import { STATUS_CODE } from "@/common/constants.js";
import {
  BIND_ENUM,
  MESSAGE_IMAGE_ENUM,
  ACTIVITY_BTN_TEXT_ENUM,
  COUPON_DISCOUNT_TEXT_ENUM,
  CHANNEL_CODE_ENUM,
  CHANNEL_CONTENT_ENUM,
  COUPON_IMAGE_ENUM,
  GROUP_MEMBER_IMAGE_ENUM,  // 拼团人员头像为空枚举
  GROUP_STATUS_ENUM,  // 拼团状态
  BROWSER_ENV_ENUM,
} from "./constants.js";

// 组件
import loading from "@/common/loading/index.js";
import dialogue from "@/common/dialogue/index.vue";
import Toast from '@/common/toast/index.js'

// 接口
import {
  getWXJSConfig,
  getActivityInfo,
  getGroupInfo,
  openGroup,
  helpGroup,
  receiveOne,
} from "@/api/index.js";

// 通用分享函数
import {
  wechatShare,
  appShare,
  alipayShare,
} from "./share.js";

export default {
  name: "index",
  data() {
    return {
      time: {
        day: "",
        hour: "",
        minute: "",
        second: "",
      },
      instruction: "2人成团，免费拿5折券",
      btnText: "",
      awardTop: {
        text: "",
      },
      awardBottom: {
        text: "",
      },
      startNumber: "",
      messageDialogue: {   // 活动状态对话框
        isShow: false,
        image: null,
        description: "",
        btnText: "",
        callback: null,
      },
      couponDialogue: {  // 优惠券对话框
        isShow: false,
        image: null,
        notice: "",
        description: "",
        btnText: "",
        callback: null,
      },

      isShowRulesDialogue: false,
      isShowShare: false,  // 是否显示分享遮罩

      activityInfo: {     // 活动信息
        errorCode: "",
        bindMobile: "",
        currentDate: "",
        endDate: "",
        headImage: "",
        leaderGroupId: "",
        memberGroupId: "",
        oneCoupon: "",
      },

      groupInfo: {    // 团信息
        groupId: "",
        leaderImage: GROUP_MEMBER_IMAGE_ENUM.EMPTY,
        memberImage: GROUP_MEMBER_IMAGE_ENUM.EMPTY,
        role: "",
        receiveProgress: 0,
        receiveTip: "",
        status: "",
      },

      sliderBar: {    // 活动进度条
        isShow: false,
        width: 0,
      },
      couponTypeItem: ["5折券", "免费券", "40元券包"],
      browserEnv: "",   // 浏览器环境

      shareDetail: {   // 分享详细信息
        imgUrl: location.href.split("index")[0] + "share_icon.png",
        title: "限量抢，和我一起领双11寄件券",
        desc: "我正在领丰巢寄件券，帮我拼团，你也有一份哦",
        link: "",
      },

      query: {  // url查询参数
        groupId: "",
        source: "",
        token: "",
        channelCode: "",
      },

      isShowDoubleBtn: false,  // 是否显示2个活动按钮
      isShowSingleBtn: false,  // 是否显示1个活动按钮
    };
  },

  computed: {
    logoNotice() {
      let channelCode = this.query.channelCode || CHANNEL_CODE_ENUM.FC;
      return CHANNEL_CONTENT_ENUM[CHANNEL_CODE_ENUM[channelCode]];
    },

    // 是否绑定手机号
    isBind () {
      return this.activityInfo.bindMobile == BIND_ENUM.ALREADY_BIND
    },

    // 活动是否结束
    isActivityEnded () {
      return this.activityInfo.errorCode == STATUS_CODE.SUCCESS_INACCESSIBLE_CODE;
    },

    // 是否为快递员
    isCourier () {
      return this.activityInfo.errorCode == STATUS_CODE.SUCCESS_COURIER_CODE;
    },

    // 是否需要开新团
    isNeedOpenGroup () {
      return !this.activityInfo.leaderGroupId;
    }
  },

  watch: {
    // 领取进度提示
    "groupInfo.receiveProgress": function (newValue) {
      if (newValue == 0) return;
      this.sliderBar.isShow = true;
      let position = {
        1: "19%",
        2: "52.5%",
        3: "86%"
      };
      window.setTimeout(() => {
        this.$nextTick().then(() => {
          this.sliderBar.width = position[newValue];
        });
      }, 100);
    },
  },

  methods: {
    // 领取1元优惠券
    receiveOneCoupon() {
      if (!this.isActivityAccessible()) return;
      loading.show();
      let data = {
        channelCode: this.query.channelCode,
      };
      receiveOne(data).then(res => {
        loading.hide();
        this.couponDialogue = {
          isShow: true,
          image: COUPON_IMAGE_ENUM.DEDUCTION_1,
          notice: "订单满8元时可用",
          description: "羊毛不多，能薅一点是一点！1元寄件券已放入你的账户",
          btnText: "我知道了",
          callback: () => {
            this.couponDialogue.isShow = false;
          },
        }
      });
    },

    // 未注册，活动结束，快递员角色
    isActivityAccessible() {
      if(this.activityInfo.errorCode == STATUS_CODE.SUCCESS_NO_APP_LOGIN) {
        this.messageDialogue = {
          isShow: true,
          image: MESSAGE_IMAGE_ENUM.FAIL,
          description: "请先登录您的丰巢APP账号，然后才能返回活动页面继续参与哦。",
          btnText: "我知道了",
          callback: () => {
            this.messageDialogue.isShow = false;
          },
        }
        return false;
      }

      if (!this.isBind) {
        Toast({
          message: "您还未登录，即将为您跳转到登录界面",
          duration: 2000,
        });
        window.setTimeout(() => {
          this.$router.push({ path: "/login" });
        }, 2000);
        return false;
      }

      if (this.isActivityEnded) {
        this.messageDialogue = {
          isShow: true,
          image: MESSAGE_IMAGE_ENUM.FAIL,
          description: "活动已结束，记得下次早点来哦",
          btnText: "我知道了",
          callback: () => {
            this.messageDialogue.isShow = false;
          },
        }
        return false;
      }

      if (this.isCourier) {
        this.messageDialogue = {
          isShow: true,
          image: MESSAGE_IMAGE_ENUM.COURIER,
          description: "抱歉，快递员无法参与此次活动",
          btnText: "我知道了",
          callback: () => {
            this.messageDialogue.isShow = false;
          },
        }
        return false;
      }

      return true;
    },

    // 活动按钮处理逻辑
    invite(e) {
      window.fio('send', {
        fc_type: 'click',
        fc_event: 'invite',
        element_name: e.target.innerText
      });
      if (!this.isActivityAccessible()) return;
     

      // 按钮为立即邀请或者为拼团拿5折券
      if (this.btnText == ACTIVITY_BTN_TEXT_ENUM.INVITE ||
        e.target.innerText == ACTIVITY_BTN_TEXT_ENUM.DISCOUNT) {
        
        if (this.isNeedOpenGroup) {  // 需要开新团
          loading.show();
          openGroup({ channelCode: this.query.channelCode }).then(res => {
            loading.hide();
            if(this.browserEnv != BROWSER_ENV_ENUM.ALIPAY) {
              this.isShowShare = true;
            }
            
            let data = res.data.data;
            this.initGroupInfo(data.groupId);
            this.groupInfo.groupId = data.groupId;
            this.activityInfo.leaderGroupId = data.groupId;
            this.share();   // 开团之后有了新的groupId,需要同时更新分享函数
            if(this.browserEnv == BROWSER_ENV_ENUM.ALIPAY) {
              alipayShare(this.shareDetail);
            }
          })
        } else {
          if(this.query.channelCode != this.groupInfo.channelCode) {
            this.messageDialogue = {
              isShow: true,
              image: MESSAGE_IMAGE_ENUM.FAIL,
              description: "您已经在其他渠道参与了本活动，请不要重复参与哦",
              btnText: "我知道了",
              callback: () => {
                this.messageDialogue.isShow = false;
              },
            };
            return;
          }
          this.share();
          if(this.browserEnv != BROWSER_ENV_ENUM.ALIPAY) {
            this.isShowShare = true;
          } else {
            alipayShare(this.shareDetail);
          }
        }
      } else if (this.btnText == ACTIVITY_BTN_TEXT_ENUM.HELP) {  // 参团
        let data = {
          groupId: this.query.groupId,
          channelCode: this.query.channelCode,
        };

        // 团已满
        if(this.groupInfo.status == GROUP_STATUS_ENUM.FULL) {
          if(this.activityInfo.leaderGroupId) {  // 自己开过团
            if(this.activityInfo.memberGroupId) {  // 自己参加过团
              if(this.activityInfo.memberGroupId == this.groupInfo.groupId) {
                this.messageDialogue = {
                  isShow: true,
                  image: MESSAGE_IMAGE_ENUM.FIGHTING,
                  description: "您已经参加过该团，不能重复参加哦",
                  btnText: "查看自己的团",
                  callback: () => {
                    this.messageDialogue.isShow = false;
                    location.href = this.joinUrlQuery(process.env.VUE_APP_SHARE_LINK, {
                      source: this.query.source,
                      channelCode: this.query.channelCode,
                    }) 
                  },
                };
              } else {
                this.messageDialogue = {
                  isShow: true,
                  image: MESSAGE_IMAGE_ENUM.FIGHTING,
                  description: "您已经参加过其他小伙伴的团啦",
                  btnText: "查看自己的团",
                  callback: () => {
                    this.messageDialogue.isShow = false;
                    location.href = this.joinUrlQuery(process.env.VUE_APP_SHARE_LINK, {
                      source: this.query.source,
                      channelCode: this.query.channelCode,
                    });
                  },
                }
              }
            } else {
              this.messageDialogue = {
                isShow: true,
                image: MESSAGE_IMAGE_ENUM.FIGHTING,
                description: "来晚了，当前团已满啦",
                btnText: "查看自己的团",
                callback: () => {
                  this.messageDialogue.isShow = false;
                  location.href = this.joinUrlQuery(process.env.VUE_APP_SHARE_LINK, {
                    source: this.query.source,
                    channelCode: this.query.channelCode,
                  });
                },
              }
            }
          } else {  // 自己未开过团
            this.messageDialogue = {
              isShow: true,
              image: MESSAGE_IMAGE_ENUM.FIGHTING,
              description: "这个团已经满人了！不着急咱自己开团",
              btnText: "自己开团赢5折寄件券",
              callback: () => {
                loading.show();
                openGroup({ channelCode: this.query.channelCode }).then(() => {
                  loading.hide();
                  location.href = this.joinUrlQuery(process.env.VUE_APP_SHARE_LINK, {
                    source: this.query.source,
                    channelCode: this.query.channelCode,
                  })           
                });
              },
            }
          }
        } else {  // 团未满
          if(this.activityInfo.memberGroupId) {  // 自己参加过别人的团
            if(this.activityInfo.leaderGroupId) { // 自己已开团
              this.messageDialogue = {
                isShow: true,
                image: MESSAGE_IMAGE_ENUM.FIGHTING,
                description: "您已经参加过其他小伙伴的团啦",
                btnText: "查看自己的团",
                callback: () => {
                  this.messageDialogue.isShow = false;
                  location.href = this.joinUrlQuery(process.env.VUE_APP_SHARE_LINK, {
                    source: this.query.source,
                    channelCode: this.query.channelCode,
                  }) 
                },
              }
            } else {  // 自己未开过团
              this.messageDialogue = {
                isShow: true,
                image: MESSAGE_IMAGE_ENUM.FIGHTING,
                description: "您已经参加过其他小伙伴的团啦!",
                btnText: "自己开团赢5折寄件券",
                callback: () => {
                  this.messageDialogue.isShow = false;
                  loading.show();
                  openGroup({ channelCode: this.query.channelCode }).then(() => {
                    loading.hide();
                    location.href = this.joinUrlQuery(process.env.VUE_APP_SHARE_LINK, {
                      source: this.query.source,
                      channelCode: this.query.channelCode,
                    })           
                  });
                },
              }
            }
          } else {   // 自己未参加过别人的团
            loading.show();
            helpGroup(data).then(res => {
              loading.hide();
              if(this.activityInfo.leaderGroupId) {   // 如果自己已经开团
                this.couponDialogue = {
                  isShow: true,
                  image: COUPON_IMAGE_ENUM.DEDUCTION_3,
                  notice: "订单满8元时可用",
                  description: "羊毛不多，能薅一点是一点！3元寄件券已放入你的账户",
                  btnText: "我知道了",
                  callback: () => {
                    this.couponDialogue.isShow = false; 
                  },
                }
              } else {  // 自己未开团
                this.couponDialogue = {
                  isShow: true,
                  image: COUPON_IMAGE_ENUM.DEDUCTION_3,
                  notice: "订单满8元时可用",
                  description: "羊毛不多，能薅一点是一点！3元寄件券已放入你的账户",
                  btnText: "自己开团拿5折抵扣券",
                  callback: () => {
                    this.couponDialogue.isShow = false;
                    loading.show();
                    openGroup({ channelCode: this.query.channelCode }).then(res => {
                      loading.hide();
                      location.href = this.joinUrlQuery(process.env.VUE_APP_SHARE_LINK, {
                        source: this.query.source,
                        channelCode: this.query.channelCode,
                      })           
                    });
                  },
                }
              }
              this.initGroupInfo(data.groupId);
            });
          }
        }
      } else if (this.btnText == ACTIVITY_BTN_TEXT_ENUM.MAIL) {   // 已参团并且邀请到好友
        if(this.query.channelCode == CHANNEL_CODE_ENUM.SF) {
          this.messageDialogue = {
            isShow: true,
            image: MESSAGE_IMAGE_ENUM.FIGHTING,
            description: "请前往”顺丰速运微信公众号-寄快递-丰巢寄件”，下单吧",
            btnText: "我知道了",
            callback: () => {
              this.messageDialogue.isShow = false;
            },
          }
        } else if (this.query.channelCode == CHANNEL_CODE_ENUM.YD) {
          this.messageDialogue = {
            isShow: true,
            image: MESSAGE_IMAGE_ENUM.FIGHTING,
            description: "请前往”韵达快递微信公众号-我要寄件-丰巢自寄”，下单吧",
            btnText: "我知道了",
            callback: () => {
              this.messageDialogue.isShow = false;
            },
          }
        } else if(this.query.channelCode == CHANNEL_CODE_ENUM.YTO) {
          location.href = process.env.VUE_APP_ORDER_YTO_LINK;
        } else if(this.browserEnv == BROWSER_ENV_ENUM.ALIPAY) {
          location.href = process.env.VUE_APP_ORDER_FC_ALIPAY_LINK;
        } else if(this.browserEnv == BROWSER_ENV_ENUM.CONSUMER_APP) {
          this.messageDialogue = {
            isShow: true,
            image: MESSAGE_IMAGE_ENUM.FIGHTING,
            description: "请前往丰巢APP首页，点击寄快递下单吧",
            btnText: "我知道了",
            callback: () => {
              this.messageDialogue.isShow = false;
            },
          }
        } else {
          location.href = process.env.VUE_APP_ORDER_FC_WECHAT_LINK;
        }
      }
    },

    // 活动信息
    initActivityInfo() {
      loading.show();
      getActivityInfo().then(res => {
        loading.hide();
        let data = res.data.data;
        this.timeCountDown(data.endDate - data.currentDate);
        res.data.data.errorCode = res.data.errorCode;
        this.activityInfo = res.data.data;
        if(this.query.groupId) {
          this.isShowDoubleBtn = false;
          this.isShowSingleBtn = true;
          this.initGroupInfo(this.query.groupId);  
        } else {
          this.groupInfo.leaderImage = data.headImage || GROUP_MEMBER_IMAGE_ENUM.LEADER;
          if(data.leaderGroupId) {   // 用户已开团
            this.isShowDoubleBtn = false;
            this.isShowSingleBtn = true;
            this.initGroupInfo(data.leaderGroupId);
          } else {  // 用户未开团
            this.isShowDoubleBtn = true;
            this.isShowSingleBtn = false;
          }
        }
      });
    },

    // 设置活动主按钮文本
    setBtnText () {
      // 如果链接包含了groupId
      if(this.query.groupId) {
        // 自己的团
        if(this.query.groupId == this.activityInfo.leaderGroupId) {
          // 团未满
          if(this.groupInfo.status == GROUP_STATUS_ENUM.NOT_FULL) {
            this.btnText = ACTIVITY_BTN_TEXT_ENUM.INVITE;
          // 团已满
          } else if(this.groupInfo.status == GROUP_STATUS_ENUM.FULL){
            this.btnText = ACTIVITY_BTN_TEXT_ENUM.MAIL;
          }
        } else {   // 别人的团
          this.btnText = ACTIVITY_BTN_TEXT_ENUM.HELP;
        }        
      } else {  // 链接不包含groupId
        if(this.activityInfo.leaderGroupId) {  // 用户开过团
          // 团未满
          if(this.groupInfo.status == GROUP_STATUS_ENUM.NOT_FULL) {
            this.btnText = ACTIVITY_BTN_TEXT_ENUM.INVITE;
          // 团已满
          } else if(this.groupInfo.status == GROUP_STATUS_ENUM.FULL){
            this.btnText = ACTIVITY_BTN_TEXT_ENUM.MAIL;
          }
        }
      }
    },

    // 拼团信息
    initGroupInfo(groupId) {
      let data = {
        groupId,
      };
      loading.show();
      getGroupInfo(data).then(res => {
        loading.hide();
        let data = res.data.data;
        data.leaderImage = data.leaderImage  ||  GROUP_MEMBER_IMAGE_ENUM.LEADER;
        if (data.status == GROUP_STATUS_ENUM.FULL) {
          data.memberImage = data.memberImage || GROUP_MEMBER_IMAGE_ENUM.MEMBER;
        } else {
          data.memberImage = data.memberImage || GROUP_MEMBER_IMAGE_ENUM.EMPTY;
        }
        this.groupInfo = data;
        
        this.setBtnText();
        this.openDiscountDialogue();
      });
    },

    // 5折券弹窗提醒
    openDiscountDialogue () {
      let discountTip = 2;   // 5折券提示
      if(this.groupInfo.receiveTip != discountTip) return;
      let description = COUPON_DISCOUNT_TEXT_ENUM[CHANNEL_CODE_ENUM[this.query.channelCode]];
      window.setTimeout( () => {
        this.couponDialogue = {
          isShow: true,
          image: COUPON_IMAGE_ENUM.DISCOUNT,
          notice: "最高可抵扣10元",
          description,
          btnText: "我知道了",
          callback: () => {
            this.couponDialogue.isShow = false;
          },
        }
      }, 1000);
    },

    // 活动倒计时
    timeCountDown(time) {
      if (time <= 0) {
        this.time = {
          day: "00",
          hour: "00",
          minute: "00",
          second: "00",
        }
        return;
      }
      time = time / 1000;
      let self = this;
      function tick() {
        time -= 1;
        let day = Math.floor(time / (24 * 60 * 60)),
          hour = Math.floor((time - day * 24 * 60 * 60) / (60 * 60)),
          minute = Math.floor((time - day * 24 * 60 * 60 - hour * 60 * 60) / 60),
          second = Math.floor(time - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60);
        self.time = {
          day: day < 10 ? "0" + day : day,
          hour: hour < 10 ? "0" + hour : hour,
          minute: minute < 10 ? "0" + minute : minute,
          second: second < 10 ? "0" + second : second,
        }
        window.setTimeout(tick, 1000);
      }
      tick();
    },

    // 设置浏览器环境
    setBrowserEnv() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") > -1) {
        this.browserEnv = BROWSER_ENV_ENUM.WECHAT;
      } else if (ua.indexOf("alipayclient") > -1) {
        this.browserEnv = BROWSER_ENV_ENUM.ALIPAY;
      } else if (this.getCookie('fc_app')) {
        this.browserEnv = BROWSER_ENV_ENUM.CONSUMER_APP;
      } else {
        this.browserEnv = BROWSER_ENV_ENUM.OTHERS;
      }
    },

    // 右上角分享
    share() {
      let shareLink = process.env.VUE_APP_SHARE_LINK,
        query = this.getShareQuery();
      shareLink = this.joinUrlQuery(shareLink, query);
      this.shareDetail.link = shareLink;

      switch (this.browserEnv) {
        case BROWSER_ENV_ENUM.WECHAT:
          getWXJSConfig({shareUrl: encodeURIComponent(document.URL.split('#')[0])}).then(res => {
            wechatShare(res.data.data, this.shareDetail);
          });
          break;

        case BROWSER_ENV_ENUM.CONSUMER_APP:
          appShare(this.shareDetail);
          break;

        default:
          break;
      }
    },

    // 获得分享参数
    getShareQuery () {
      let shareQuery = {};
      if(this.browserEnv == BROWSER_ENV_ENUM.ALIPAY) {
        shareQuery.source = this.query.source || BROWSER_ENV_ENUM.ALIPAY;
      }

      if(this.query.channelCode) {
        shareQuery.channelCode = this.query.channelCode;
      }

      if(this.groupInfo.groupId) {
        shareQuery.groupId = this.groupInfo.groupId;
      }
      return shareQuery;
    },

    // 获得app的cookie
    getCookie(name) {
      var arr
      var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
      arr = document.cookie.match(reg)
      if (arr && arr[2]) {
        return arr[2]
      } else {
        return false
      }
    },

    // 添加页面统计数据
    addStatistics() {
      window.fio('init', {
        fc_pagename: 'activity-2019-11-11-coupon',
        fc_page: 'activity-2019-11-11-coupon'
      })
    },

    // 设置请求头
    setRequestHeaders() {
      this.$store.commit("setHeaders", {
        source: this.query.source,
        token: this.query.token,
      })
    },

    /*
      解析url,获得查询参数
      https://www.edms.fcbox.com/index.html?channelCode=e-sf&source=alipay#/
    */
    parseUrlQuery(url) {
      let query = {},
        questionIndex = url.indexOf("?") + 1;
      if (questionIndex == 0) {
        return query;
      }
      let hashIndex = url.indexOf("#");
      if (hashIndex == -1) {
        hashIndex = url.length;
      }

      let queryStr = url.slice(questionIndex, hashIndex),
        queryArr = queryStr.split("&");
      for (let i = 0; i < queryArr.length; ++i) {
        let item = queryArr[i].split("=");
        if (item[1]) {
          query[item[0]] = item[1];
        }
      }
      return query;
    },

    /*
      查询参数拼接
      @url: {String}, 链接
      @query: {Object}, 查询参数键值对
    */
    joinUrlQuery(url, query) {
      let keys = Object.keys(query);
      if (keys.length == 0) return url;
      url += "?";
      for (let i = 0; i < keys.length; ++i) {
        url += keys[i] + "=" + query[keys[i]] + "&";
      }
      return url.slice(0, url.length - 1);
    },

    // 注入alipay的分享函数
    alipayShareEvent () {
      if(this.browserEnv != BROWSER_ENV_ENUM.ALIPAY) return;
      let that = this;
      function ready(callback) {
        // 如果jsbridge已经注入则直接调用
        if (window.AlipayJSBridge) {
          callback && callback();
        } else {
          // 如果没有注入则监听注入的事件
          document.addEventListener('AlipayJSBridgeReady', callback, false);
        }
      }

      ready(function() {
        AlipayJSBridge.call('setOptionMenu', {
          title : '分享',
        });
      
        document.addEventListener('optionMenu', function(e) {
          alipayShare(that.shareDetail);
        }, false);
      });
    }
  },

  mounted() {
    this.query = this.parseUrlQuery(location.href);
    this.query.channelCode = this.query.channelCode || CHANNEL_CODE_ENUM.FC;
    sessionStorage.setItem("fio_track_channelid", this.query.channelCode);
    this.setRequestHeaders();
    this.setBrowserEnv();
    this.addStatistics();
    this.share();
    this.alipayShareEvent();
    this.initActivityInfo();
  },

  components: {
    dialogue,
  }
}
